import { PartnerStatusEnum } from '@/shared/enums';
import { R } from '@/features/profile/resources/ProfileResources.resx';

export const getHouseholdMemberStatus = (status: PartnerStatusEnum): string => {
    switch (status) {
        case PartnerStatusEnum.NoPartner:
            return R.NoPartner;
        case PartnerStatusEnum.Invited:
            return R.Awaiting;
        case PartnerStatusEnum.Active:
            return R.Created;
        default:
            return '';
    }
};
